// Редьюсер и селекторы для IntegrationsPage
import { createReducer } from '@reduxjs/toolkit';
import { AppState } from '../../global/types';
import * as actions from './actions';
import { IntegrationsPageState } from './types';

const initialState: IntegrationsPageState = {
  list: { data: null, loading: false, error: null },
  selected: { code: null, data: null, loading: false, error: null },
  mutation: { loading: false, error: null },
};

const reducer = createReducer(initialState, {
  // Получение всех интеграций
  [actions.getIntegrations.REQUEST]: (state) => {
    state.list.loading = true;
    state.list.error = null;
  },
  [actions.getIntegrations.SUCCESS]: (state, action) => {
    state.list.data = action.payload || null;
    state.list.loading = false;
  },
  [actions.getIntegrations.ERROR]: (state, action) => {
    state.list.error = action.payload || 'Ошибка загрузки интеграций';
    state.list.loading = false;
  },

  // Получение одной интеграции по коду
  [actions.getIntegrationByCode.REQUEST]: (state, action) => {
    state.selected.loading = true;
    state.selected.error = null;
    state.selected.code = action.payload?.code || null;
  },
  [actions.getIntegrationByCode.SUCCESS]: (state, action) => {
    state.selected.data = action.payload || null;
    state.selected.loading = false;
  },
  [actions.getIntegrationByCode.ERROR]: (state, action) => {
    state.selected.error = action.payload || 'Ошибка загрузки интеграции';
    state.selected.loading = false;
  },

  // Любые мутационные операции помечаем единым флагом
  [actions.createIntegration.REQUEST]: (state) => {
    state.mutation.loading = true;
    state.mutation.error = null;
  },
  [actions.addNetworkToIntegration.REQUEST]: (state) => {
    state.mutation.loading = true;
    state.mutation.error = null;
  },
  [actions.removeNetworkFromIntegration.REQUEST]: (state) => {
    state.mutation.loading = true;
    state.mutation.error = null;
  },
  [actions.setNetworkActive.REQUEST]: (state) => {
    state.mutation.loading = true;
    state.mutation.error = null;
  },
  [actions.updateIntegrationInfo.REQUEST]: (state) => {
    state.mutation.loading = true;
    state.mutation.error = null;
  },

  [actions.createIntegration.SUCCESS]: (state) => {
    state.mutation.loading = false;
  },
  [actions.addNetworkToIntegration.SUCCESS]: (state) => {
    state.mutation.loading = false;
  },
  [actions.removeNetworkFromIntegration.SUCCESS]: (state) => {
    state.mutation.loading = false;
  },
  [actions.setNetworkActive.SUCCESS]: (state) => {
    state.mutation.loading = false;
  },
  [actions.updateIntegrationInfo.SUCCESS]: (state) => {
    state.mutation.loading = false;
  },

  [actions.createIntegration.ERROR]: (state, action) => {
    state.mutation.loading = false;
    state.mutation.error = action.payload || 'Ошибка сохранения';
  },
  [actions.addNetworkToIntegration.ERROR]: (state, action) => {
    state.mutation.loading = false;
    state.mutation.error = action.payload || 'Ошибка сохранения';
  },
  [actions.removeNetworkFromIntegration.ERROR]: (state, action) => {
    state.mutation.loading = false;
    state.mutation.error = action.payload || 'Ошибка сохранения';
  },
  [actions.setNetworkActive.ERROR]: (state, action) => {
    state.mutation.loading = false;
    state.mutation.error = action.payload || 'Ошибка сохранения';
  },
  [actions.updateIntegrationInfo.ERROR]: (state, action) => {
    state.mutation.loading = false;
    state.mutation.error = action.payload || 'Ошибка сохранения';
  },
});

// Селекторы
const integrationsList = (state: AppState) =>
  state.integrationsPageReducer.list.data;

const integrationsListLoading = (state: AppState) =>
  state.integrationsPageReducer.list.loading;

const selectedIntegration = (state: AppState) =>
  state.integrationsPageReducer.selected.data;

const selectedIntegrationLoading = (state: AppState) =>
  state.integrationsPageReducer.selected.loading;

const integrationsMutationLoading = (state: AppState) =>
  state.integrationsPageReducer.mutation.loading;

export const selectors = {
  integrationsList,
  integrationsListLoading,
  selectedIntegration,
  selectedIntegrationLoading,
  integrationsMutationLoading,
};

export { reducer as integrationsPageReducer };
